var map = {
	"./dark/close.png": 18111,
	"./dark/deposit-bg.png": 25037,
	"./dark/energy-bg.png": 38055,
	"./dark/follow-bg.png": 13418,
	"./dark/header-bg.png": 8826,
	"./dark/home-menu/inbox.png": 12789,
	"./dark/home-menu/security.png": 99903,
	"./dark/home-menu/share.png": 99152,
	"./dark/home-menu/signUpBonus.png": 55772,
	"./dark/home-menu/vip.png": 48580,
	"./dark/invite-friends/box-bg.png": 85692,
	"./dark/invite-friends/total-bg.png": 79963,
	"./dark/light.png": 87103,
	"./dark/logo.png": 23270,
	"./dark/pointer-active.png": 15593,
	"./dark/redeem-bg.png": 42823,
	"./dark/redeem-input.png": 56816,
	"./dark/reward-bg.png": 74992,
	"./dark/reward-item-bg.png": 46426,
	"./dark/tabbar/help-slot.png": 40048,
	"./dark/tabbar/home.png": 4857,
	"./dark/tabbar/promotions.png": 27178,
	"./dark/tabbar/share.png": 89923,
	"./dark/tabbar/task.png": 33711,
	"./dark/verification/step1.png": 90972,
	"./dark/verification/step2.png": 75255,
	"./dark/verification/step3.png": 32238,
	"./dark/withdraw-bg.png": 75329,
	"./light/close.png": 55201,
	"./light/deposit-bg.png": 82055,
	"./light/energy-bg.png": 44497,
	"./light/follow-bg.png": 7552,
	"./light/header-bg.png": 47324,
	"./light/home-menu/inbox.png": 84211,
	"./light/home-menu/security.png": 46529,
	"./light/home-menu/share.png": 84154,
	"./light/home-menu/signUpBonus.png": 44114,
	"./light/home-menu/vip.png": 67922,
	"./light/invite-friends/box-bg.png": 42630,
	"./light/invite-friends/total-bg.png": 56961,
	"./light/light.png": 17993,
	"./light/logo.png": 94892,
	"./light/pointer-active.png": 95607,
	"./light/redeem-bg.png": 75937,
	"./light/redeem-input.png": 80250,
	"./light/reward-bg.png": 68978,
	"./light/reward-item-bg.png": 59920,
	"./light/tabbar/help-slot.png": 98218,
	"./light/tabbar/home.png": 56571,
	"./light/tabbar/promotions.png": 80184,
	"./light/tabbar/share.png": 89717,
	"./light/tabbar/task.png": 19109,
	"./light/verification/step1.png": 83054,
	"./light/verification/step2.png": 1829,
	"./light/verification/step3.png": 84316,
	"./light/withdraw-bg.png": 86451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38735;